import { Action } from '@ngrx/store';

import { RecommendationActionType } from './recommendation-action-type.enum';

export class SelectEmployeeRecommendation implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.SelectEmployeeRecommendation;

  constructor(public readonly payload: number) { }
}

export class SelectEmployeeRecommendationCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.SelectEmployeeRecommendationCompleted;

  constructor(public readonly payload: number) { }
}

export class SelectEmployeeRecommendationFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.SelectEmployeeRecommendationFailed;

  constructor(public readonly payload: string) { }
}
